<template>
  <div>
    <div v-show="conShow">
      <div>
        <headMenu @showApply="showApply"></headMenu>
      </div>
      <div style="background: #F5F7F9">
        <div>
          <img class="headImgSty" src="../assets/about/about.png" alt="">
        </div>
        <div class="about-con">
          <div class="title">
            <div class="con-title">公司介绍</div>
            <div class="con-text">COMPANY PROFILE</div>
          </div>
          <div class="con-details">
            通远股份成立于2008年，总部位于北京，专注于全球人工智能领域知识产权保护与转化，以及助力国内高校提升大学生研究写作能力，并系统化防范学术不端行为。作为助力中国教育改革得积极践行者，通远从研发、产品到一线运营服务大量应用信息化、智能化、大数据技术，同时通过管理信息系统实现更高水平的教育信息化服务。
          </div>
        </div>
        <div class="about-con">
          <div class="title">
            <div class="con-title">公司规模</div>
            <div class="con-text">COMPANY PROFILE</div>
          </div>
          <div class="con-details">
            研发中心位于北京，经过多年锐意进取获得了创新型企业称号、最具成长力科创企业称号等，拥有超过50项发明创造专利，数百项软件著作权。并在上海、广州、武汉、长沙、郑州、南京多地设立了分公司。<br>
            目前已为全国 1200 多家机构提供了专业服务，包含普通高校、教育主管单位、国企事业单位、期刊杂志社、科研院所等。
          </div>
          <div class="title">
            <div class="con-title">深耕高教行业，产品技术先进</div>
          </div>
          <div class="con-details">
            基于十年以上高等教育行业的服务经验，通远研发中心将先进大规模文本信息技术与人工智能大数据技术深度融合应用，自主研发了论禹AI研学平台、论禹科研文献新颖性评价系统,国内数百所高校采用的格子达毕业设计（论文）全过程管理系统、格子达论文学术规范检测系统，以及响应教育部学位中心本科毕业论文抽检的格质评本科毕业论文送审平台，用科技助力中国高校的高质量发展。
          </div>
          <div class="title">
            <div class="con-title">超专业团队，七星格服务</div>
          </div>
          <div class="con-details">
            通远股份拥有一支强大的国际化专业团队，主要由多名海归AI博士及教育教学专家和信息化专家组成，面向高校的七星格服务由毕业于国内知名院校的数百名运营顾问们提供。通远服务团队一直秉承“快速响应,精益求精”的理念，以“客户为先”为服务原则，力求为客户持续提供 “可靠稳定、先进专业”的优质服务。
          </div>
        </div>
          <div class="title">
            <div class="con-title">发展历程</div>
            <div class="con-text">DEVELOPMENT HISTOR</div>
          </div>
          <div class="scroll" style="display: flex">
            <div class="con-content">
              <div class="fz-year">2022</div>
              <div class="fz-text">格子达论文学术规范检测“web 4.0”上线。</div>
            </div>
            <div class="con-content">
              <div class="fz-year">2021</div>
              <div class="fz-text">与普天和平达成战略合作， 首推“格质评本科毕业论文送审平台”。</div>
            </div>
            <div class="con-content">
              <div class="fz-year">2020</div>
              <div class="fz-text">通远股份与【601098】中南传媒沛心、国家机械工业出版社 达成战略合作，注册用户突破两千万。</div>
            </div>
            <div class="con-content">
              <div class="fz-year">2017</div>
              <div class="fz-text">推出格子达大学生毕业设计(论文)过程管理系统。 湖南省专业综合评价抽检查重服务指定服务商。</div>
            </div>
            <div class="con-content">
              <div class="fz-year">2016</div>
              <div class="fz-text">获得国家级高新技术企业认定，完成股份制改造。 河南省学位论文抽检查重服务指定服务商。</div>
            </div>
            <div class="con-content">
              <div class="fz-year">2015</div>
              <div class="fz-text">获得A 轮千万融资，首推学生自查+学校审查模式， 注册用户突破千万。</div>
            </div>
            <div class="con-content">
              <div class="fz-year">2014</div>
              <div class="fz-text">升级为 格子达Gocheck 品牌，注册用户突破300万。</div>
            </div>
            <div class="con-content">
              <div class="fz-year">2013</div>
              <div class="fz-text">自主研发的Gocheck论文检测系统面世， 注册用户突破100万。</div>
            </div>
            <div class="con-content">
              <div class="fz-year">2012</div>
              <div class="fz-text">为国家审计署提供了查重系统服务。</div>
            </div>
            <div class="con-content">
              <div class="fz-year">2011</div>
              <div class="fz-text">成功研发业内首个文本相似性比对系统VTTMS。</div>
            </div>
            <div class="con-content">
              <div class="fz-year">2009</div>
              <div class="fz-text">年获北京市教委立项支持。</div>
            </div>
            <div class="con-content">
              <div class="fz-year">2008</div>
              <div class="fz-text">成立于北京。</div>
            </div>
          </div>
          <div class="about-con">
            <div class="title">
              <div class="con-title">荣誉资质</div>
              <div class="con-text">HONOR</div>
            </div>
            <div class="con-details">
              通远股份专注于全球人工智能领域知识产权的保护与转化，十余年深耕核心技术研发和产品创新。在产品化发展的过程中创立了自主品牌“格子达”、“格质评”等多个品牌，拥有五十多项发明专利、数百项软件著作权、多项软件产品认证，斩获科技小巨人、国家级高新技术企业认定，多次获得省级重点项目专项支持、并受邀参与多项政府重点科技计划项目。
            </div>
            <div>
              <img style="width: 100%" src="../assets/about/about-fz.png" alt="">
            </div>
          </div>
          <div class="title">
            <div class="con-title">联系我们</div>
            <div class="con-text">CONTACT US</div>
          </div>
<!--          <div class="lxwm">-->
<!--            <div style="display: flex">-->
<!--              <div class="con-food">-->
<!--                <div class="foot-title">北京总部</div>-->
<!--                <div class="foot-text">北京市西城新街口普天得胜科技园主楼415 室</div>-->
<!--              </div>-->
<!--              <div class="con-food">-->
<!--                <div class="foot-title">湖南分部</div>-->
<!--                <div class="foot-text">长沙市芙蓉区万家丽中路旺德府国际大厦 14 楼</div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div style="display: flex">-->
<!--              <div class="con-food">-->
<!--                <div class="foot-title">上海分部</div>-->
<!--                <div class="foot-text">上海市杨浦区长阳路1687号1408室</div>-->
<!--              </div>-->
<!--              <div class="con-food">-->
<!--                <div class="foot-title">湖北分部</div>-->
<!--                <div class="foot-text">武汉经济技术开发区车城东路10号创思汇科技大厦16楼-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        <div class="kf">
          客服热线：400-699-3389
        </div>
        <div class="footSty"></div>
      </div>
    </div>
    <applyDetails ref="apply" @returnPage="returnPage"></applyDetails>
  </div>
</template>

<script>
import headMenu from "@/head/headMenu.vue";
import applyDetails from "@/head/components/applyDetails.vue";

export default {
  name: "about",
  components: {applyDetails, headMenu},
  data() {
    return {
      conShow: true
    }
  },
  mounted() {
    this.conShow = true
    window.scroll(0, 0);
  },
  methods: {
    showApply() {
      this.conShow = false
      this.$refs.apply.init()
    },
    returnPage() {
      this.conShow = true
    },
  }
}
</script>

<style scoped>
.lxwm{
    margin-left: 20px;
}
.con-food{
    width:160px;
    height: 140px;
    background: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.08);
    border-radius: 5px;
    margin-right: 15px;
    margin-bottom: 15px;
}
.fz-year{
    font-size: 18px;
    font-weight: bold;
    color: #005CE5;
    text-align: left;
    margin: 10px;
    width: 130px;
}
.fz-text{
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    white-space: break-spaces;
    margin: 10px;
    text-align: left;
    line-height: 24px;
}
.title{
    display: flex;
    padding: 15px
}
.con-details{
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    white-space: initial;
    line-height: 30px;
    text-align: left;
    padding: 0 10px 0 10px;
}
.kf{
    font-size: 18px;
    font-weight: 400;
    color: #999999;
    padding-bottom: 40px;
}
.foot-title{
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    text-align: left;
    margin: 15px;
}
.foot-text{
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    text-align: left;
    margin: 15px;
    line-height: 24px;
}
.con-title{
    font-size: 18px;
    font-weight: bold;
    color: #005CE5;
}
.con-text{
    position: absolute;
    margin-top: 6px;
    margin-left: 80px;
    font-size: 15px;
    font-weight: bold;
    color: #E0E0E0;
}
.headImgSty{
    width: 95%;
    margin-top: 15px;
}
.about-con{
    width: 94%;
    position: relative;
    margin: auto;
    left: 0;
    right: 0;
    background: #FFFFFF;
    border-radius: 10px;
    margin-top: 15px;
}
.scroll{
    text-align: center;
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
    margin: 8px;
}
.scroll::-webkit-scrollbar {display:none}
.con-content{
    width: 40%;
    height: 210px;
    background: #FFFFFF;
    position: relative;
    margin: 8px;
    border-radius: 5px;
    white-space: nowrap;
    box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.08);
    /*display: inline-block;*/
}
.footSty{
    margin-bottom: 50px;
}
</style>